import { render, staticRenderFns } from "./FormChooser.vue?vue&type=template&id=ffa369e8&scoped=true&"
import script from "./FormChooser.vue?vue&type=script&lang=js&"
export * from "./FormChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa369e8",
  null
  
)

export default component.exports